module.exports = __webpack_public_path__ + "static/img/4.7f8bb9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/hz/4.png
// module id = n3fL
// module chunks = 202